import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const FormFieldset = props => (
  <fieldset className={cx(styles.fieldset, props.className)}>
    <legend className={cx(styles.legend, props.hideLegend && styles.hideLegend)}>{props.legend}</legend>
    {props.children}
  </fieldset>
)

FormFieldset.propTypes = {
  className: PropTypes.string,
  legend: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hideLegend: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default FormFieldset
